import { c as _c } from "react-compiler-runtime"; // Two column layout matching the UX mockup. Left column is narrower
// (recording, meeting details, notes), right column is wider (recap tabs).
// When `right` is absent (no recap-side assets selected), the layout
// collapses to a single centered column.
import { Flex } from 'foundations-components/components/Flex';
import { useIsMobile } from '../hooks/useIsMobile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicPageLayout = t0 => {
  const $ = _c(14);
  const {
    left,
    right
  } = t0;
  const isMobile = useIsMobile();
  const padding = isMobile ? "400" : "600";
  if (!right) {
    let t1;
    if ($[0] !== left || $[1] !== padding) {
      t1 = /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "400",
        padding: padding,
        maxInlineSize: "600px",
        marginInline: "auto",
        children: left
      });
      $[0] = left;
      $[1] = padding;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  const t1 = isMobile ? "column" : "row";
  const t2 = isMobile ? undefined : "42%";
  const t3 = isMobile ? undefined : 0;
  let t4;
  if ($[3] !== left || $[4] !== t2 || $[5] !== t3) {
    t4 = /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "400",
      flexBasis: t2,
      flexShrink: t3,
      children: left
    });
    $[3] = left;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== right) {
    t5 = /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "400",
      flexGrow: 1,
      children: right
    });
    $[7] = right;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== padding || $[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = /*#__PURE__*/_jsxs(Flex, {
      flexDirection: t1,
      gap: "400",
      padding: padding,
      maxInlineSize: "1200px",
      marginInline: "auto",
      children: [t4, t5]
    });
    $[9] = padding;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};